<template>
  <div v-if="hasAtLeastOneSection">
    <CSidebarNavTitle v-translate>Administration</CSidebarNavTitle>
    <template v-if="hasPerm('collaborator.list')">
      <CSidebarNavItem
          :name="$gettext('Collaborators')"
          :to="{name: 'event.collaborators', params: {picaServiceId: picaServiceId}}"
          icon="cip-add-user"
      />
    </template>
    <template v-if="canSeeTransactions">
      <CSidebarNavItem
          :name="$gettext('Transactions')"
          :to="{name: 'event.accounting', params: {picaServiceId: picaServiceId}}"
          icon="cipCreditCard02"
      />
    </template>
    <template v-if="canSeeMovements">
      <CSidebarNavItem
          :name="$gettext('Transactions')"
          :to="{name: 'event.movements', params: {picaServiceId: picaServiceId}}"
          icon="cipCoinsSwap"
      />
    </template>
    <template v-if="canSeeChargebacks">
      <CSidebarNavItem
          :name="$gettext('Disputes')"
          :to="{name: 'event.chargebacks', params: {picaServiceId: picaServiceId}}"
          icon="cipTriangleWarning"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'AdministrationNav',
  computed: {
    ...mapGetters('event', [
      'picaServiceId'
    ]),
    canSeeTransactions() {
      return this.hasPerm('accounting.transactions.list')
    },
    canSeeMovements() {
      return this.hasPerm('accounting.movements.list')
    },
    canSeeChargebacks() {
      return this.hasPerm('accounting.chargeback.list')
    },
    hasAtLeastOneSection() {
      return this.hasPerm('collaborator.list')
          || this.canSeeTransactions
          || this.canSeeMovements
          || this.canSeeChargebacks
    },
  }
}
</script>
